import styled from "styled-components";

    export const ProjectContainer = styled.div`
    background-image: linear-gradient(to bottom, #434343, #3f3f3f, #3b3a3b, #373636, #333232, #333232, #333232, #333232, #373636, #3b3a3b, #3f3f3f, #434343);
    background-position: center;
    background-size: cover;
    min-height: 80vh;
    display: flex;
    flex-direction: column;
    align-items: center;  
    text-align: center;
    
    .rec.rec-arrow {
        border-radius: 35%;
        background-color: #76b852;
    }
    /* round buttons on hover */
    .rec.rec-arrow:hover {
        border-radius: 50%;
        background-color: #76b852;
    }
    /* hide disabled buttons */
    .rec.rec-arrow:disabled {
        visibility: hidden;
    }
    .rec-carousel-item:focus {
        outline: none;
        box-shadow: inset 0 0 1px 1px lightgrey;
    }
    .rec.rec-dot {
        background: #grey;
        border: 2px #333 solid;
        border-radius: 1;
      }
      .rec.rec-dot_active {
        background: #4AF626;
        box-shadow: 0 0 1px 3px green;
      }

      @media only screen and (max-width: 600px){
        min-height: 55vh;
    }

    
.mini-preview-wrapper {
    -moz-box-sizing: content-box;
    box-sizing: content-box;
    position: absolute;
    overflow: hidden;
    z-index: -1;
    opacity: 0;
    margin-top: -4px;
    border: solid 1px #000;
    box-shadow: 4px 4px 6px rgba(0, 0, 0, .3);
    transition: z-index steps(1) .3s, opacity .3s, margin-top .3s;
  }
  
  a:hover .mini-preview-wrapper {
    z-index: 2;
    opacity: 1;
    margin-top: 6px;
    transition: opacity .3s, margin-top .3s;
  }
  
  .mini-preview-loading, .mini-preview-cover {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;  
  }
  
  .mini-preview-loading {
    display: table;
    height: 100%;
    width: 100%;
    font-size: 1.25rem;
    text-align: center;
    color: #f5ead4;
    background-color: #59513f;
  }
  
  .mini-preview-loading::before {
    content: 'Loading...';
    display: table-cell;
    text-align: center;
    vertical-align: middle;
  }
  
  .mini-preview-cover {
    background-color: rgba(0, 0, 0, 0); /* IE fix */
  }
  
  .mini-preview-frame {
    border: none;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  .tiptext { 
    cursor:pointer;
}
.description {
    display:block;
    position:absolute;
    border:1px solid #000;
    width:100%;
    height: 80vh;
}
    `;
    export const ProjectH1 = styled.h1`
    padding-top: 12px;
    font-size: clamp(1rem, 10vw, 4rem);
    font-family: 'Source Code Pro', monospace;
    word-wrap: break-word;
    color: #4AF626;
    margin-bottom: 1rem;
    letter-spacing: 3px;
`;
   

    
